// extracted by mini-css-extract-plugin
export default {"hint":"shareVideo_hint__QNfqt"};